import styled from "styled-components";

export const QuickNavWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 65px;
  z-index: 1500;
  box-shadow: 0 -4px 15px rgba(0,0,0,0.08);

  @media (min-width: 769px) {
    position: sticky;
    top: 60px;
    border-top: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    height: 50px;
    padding: 0 40px;
    justify-content: center;
    gap: 30px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.03);
    background: white;
    margin-bottom: 10px;
  }
`;

export const QuickNavItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: #757575;
  font-size: 11px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  padding: 8px;
  border-radius: 12px;

  &.active {
    color: #0c8de3;
    background: rgba(12, 141, 227, 0.08);
    transform: translateY(-2px);
    
    i, svg {
      color: #0c8de3;
      filter: drop-shadow(0 0 5px rgba(12, 141, 227, 0.3));
    }
  }

  i, svg {
    font-size: 22px;
    margin-bottom: 4px;
    transition: transform 0.3s;
  }

  &:hover:not(.active) {
    color: #0c8de3;
    i, svg {
      transform: scale(1.1);
    }
  }

  @media (min-width: 769px) {
    flex-direction: row;
    font-size: 14px;
    gap: 10px;
    padding: 6px 16px;
    border-radius: 20px;
    height: 36px;

    &.active {
      transform: none;
      box-shadow: 0 2px 8px rgba(12, 141, 227, 0.15);
    }

    i, svg {
      font-size: 18px;
      margin-bottom: 0;
    }
  }
`;

export const NavLabel = styled.span`
  font-weight: 500;
`;
